import { FC } from 'react'
import { useNavigate, useParams } from 'react-router-dom'

import { ResourceHeader } from '@factorialco/f0-react/dist/experimental'

import { useNavigation } from 'modules/core/hooks/useNavigation'
import i18n from 'modules/core/lib/i18n'

export const TemplateSettingsHeader: FC = () => {
  const { navigation } = useNavigation()
  const navigate = useNavigate()
  const { templateId } = useParams()

  return (
    <ResourceHeader
      title={i18n.t('performance_process.reviews.templates.edit.title')}
      primaryAction={{
        label: i18n.t('performance_process.reviews.templates.edit.back_to_overview'),
        onClick: () =>
          navigate(
            navigation.performanceProcess.reviews.templates.template.fullPath({
              templateId: String(templateId),
            })
          ),
      }}
    />
  )
}
